// extracted by mini-css-extract-plugin
export var checkboxInputRow = "z_sD";
export var checkboxInputColumn = "z_sF";
export var inputOptionRow = "z_qj";
export var inputOptionColumn = "z_qk";